import { ApiClient } from "./api-client";
import { AppException } from "../exceptions/exceptions";
import { CommonErrorCodes } from "../errors/common-error-codes";
import { IUser } from "../types/user";

export const getAllUsers = async (): Promise<IUser[]> => {
  const client = ApiClient.getInstance();
  try {
    const response = await client.get("/admin/user-list");
    return response.data as IUser[];
  } catch (e) {
    throw new AppException("User not found", CommonErrorCodes.NOT_FOUND);
  }
};
